<form [formGroup]="frmFields" class="g-3 p-2">

  <!-- Registration Number -->
  <div class="row mt-3">
    <div class="col-md-4">
      <div class="input-group">
        <input type="text" formControlName="registration_number" placeholder="Registration Number"
          class="form-control form-control-sm text-uppercase"
          [ngClass]="{ 'is-invalid': (f.registration_number?.touched || submitted) && f.registration_number?.errors?.required }">
        <div class="input-group-append">
          <button type="button" class="btn btn-success btn-sm" (click)="lookupVehicle()">Lookup</button>
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="(f.registration_number?.touched || submitted) && f.registration_number?.errors?.required">Registration number is required.</div>
    </div>
  </div>

  <!-- Make / Model / Year / GVW / Value -->
  <div class="row mt-3">
    <div class="col-md-2">
      <input type="text" formControlName="make" placeholder="Make" class="form-control form-control-sm"
        [ngClass]="{ 'is-invalid': (f.make?.touched || submitted) && f.make?.errors?.required }">
      <div class="invalid-feedback" *ngIf="(f.make?.touched || submitted) && f.make?.errors?.required">Make is required.</div>
    </div>
    <div class="col-md-2">
      <input type="text" formControlName="model" placeholder="Model" class="form-control form-control-sm"
        [ngClass]="{ 'is-invalid': (f.model?.touched || submitted) && f.model?.errors?.required }">
      <div class="invalid-feedback" *ngIf="(f.model?.touched || submitted) && f.model?.errors?.required">Model is required.</div>
    </div>
    <div class="col-md-2">
      <input type="text" formControlName="year" placeholder="Year" class="form-control form-control-sm" maxlength="4"
        [ngClass]="{ 'is-invalid': (f.year?.touched || submitted) && f.year?.errors?.required }">
      <div class="invalid-feedback" *ngIf="(f.year?.touched || submitted) && f.year?.errors?.required">Year is required.</div>
    </div>
    <div class="col-md-3" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Gross Vehicle Weight</mat-label>
        <mat-select formControlName="gross_vehicle_weight" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.gross_vehicle_weight?.touched || submitted) && f.gross_vehicle_weight?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let w of staticData.gross_vehicle_weight_options" [value]="w">{{w}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.gross_vehicle_weight?.touched || submitted) && f.gross_vehicle_weight?.errors?.required">Gross vehicle weight is required.</div>
    </div>
    <div class="col-md-3">
      <div class="input-group">
        <div class="input-group-prepend"><span class="input-group-text bg-success text-white">&pound;</span></div>
        <input type="number" formControlName="value" placeholder="Vehicle Value"
          class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.value?.touched || submitted) && f.value?.errors?.required }">
      </div>
      <div class="invalid-feedback" *ngIf="(f.value?.touched || submitted) && f.value?.errors?.required">Value is required.</div>
    </div>
  </div>

  <!-- Cover Type / Driving Restriction / Mileage -->
  <div class="row mt-3">
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Cover Type</mat-label>
        <mat-select formControlName="cover_type" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.cover_type?.touched || submitted) && f.cover_type?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let c of staticData.cover_types" [value]="c">{{c}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.cover_type?.touched || submitted) && f.cover_type?.errors?.required">Cover type is required.</div>
    </div>
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Driving Restriction</mat-label>
        <mat-select formControlName="driving_restriction" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.driving_restriction?.touched || submitted) && f.driving_restriction?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let d of staticData.driving_restrictions" [value]="d">{{d}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.driving_restriction?.touched || submitted) && f.driving_restriction?.errors?.required">Driving restriction is required.</div>
    </div>
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Annual Mileage</mat-label>
        <mat-select formControlName="mileage" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.mileage?.touched || submitted) && f.mileage?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let m of staticData.mileage_options" [value]="m">{{m}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.mileage?.touched || submitted) && f.mileage?.errors?.required">Mileage is required.</div>
    </div>
  </div>

  <!-- Extended Use -->
  <div class="row mt-3">
    <div class="col-md-12">
      <h6 class="text-white">Extended Use — Please select any additional use required below</h6>
      <div formGroupName="extended_use">
        <div><mat-checkbox formControlName="personal_business_use">Personal business use</mat-checkbox></div>
        <div><mat-checkbox formControlName="livestock_carriage">Carriage of any horse, animal and/or other living creatures for hire and/or reward</mat-checkbox></div>
        <div><mat-checkbox formControlName="contract_work">Use in connection with the undertaking of contract work</mat-checkbox></div>
      </div>
    </div>
  </div>

  <!-- Green Card / Registered Owner / Kept Overnight -->
  <div class="row mt-3">
    <div class="col-md-4">
      <label>Do you require Annual Green Card?</label>
      <mat-radio-group class="row" formControlName="green_card" aria-label="green_card">
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
      <small class="text-danger" *ngIf="(f.green_card?.touched || submitted) && f.green_card?.errors?.required">Please select an option.</small>
    </div>
    <div class="col-md-4">
      <label>Is the proposer the registered owner?</label>
      <mat-radio-group class="row" formControlName="is_registered_owner" aria-label="is_registered_owner">
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
      <small class="text-danger" *ngIf="(f.is_registered_owner?.touched || submitted) && f.is_registered_owner?.errors?.required">Please select an option.</small>
    </div>
    <div class="col-md-4">
      <label>Is this vehicle kept overnight at correspondence postcode?</label>
      <mat-radio-group class="row" formControlName="is_kept_overnight" aria-label="is_kept_overnight">
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
      <small class="text-danger" *ngIf="(f.is_kept_overnight?.touched || submitted) && f.is_kept_overnight?.errors?.required">Please select an option.</small>
    </div>
  </div>

  <!-- Owner (conditional) -->
  <div class="row mt-3" *ngIf="frmFields.get('is_registered_owner')?.value == 'No'">
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Registered Owner</mat-label>
        <mat-select formControlName="ownership" class="form-control form-control-sm">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let o of staticData.ownership_options" [value]="o">{{o}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <input type="text" formControlName="owner_name" placeholder="Name of Owner" class="form-control form-control-sm">
    </div>
  </div>

  <!-- Overnight Postcode (conditional) -->
  <div class="row mt-3" *ngIf="frmFields.get('is_kept_overnight')?.value == 'No'">
    <div class="col-md-4">
      <input type="text" formControlName="postcode" placeholder="Overnight Postcode" class="form-control form-control-sm"
        [ngClass]="{ 'is-invalid': (f.postcode?.touched || submitted) && !frmFields.get('postcode')?.value }">
      <div class="invalid-feedback" *ngIf="(f.postcode?.touched || submitted) && !frmFields.get('postcode')?.value">Postcode is required.</div>
    </div>
  </div>

  <!-- Tracker / NCD -->
  <div class="row mt-3">
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Is the vehicle fitted with a tracker?</mat-label>
        <mat-select formControlName="tracker" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.tracker?.touched || submitted) && f.tracker?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let t of staticData.tracker_types" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.tracker?.touched || submitted) && f.tracker?.errors?.required">Tracker is required.</div>
    </div>
    <div class="col-md-4" *ngIf="staticData && modelObj?.rating_type == 'ncd'">
      <mat-form-field class="w-100">
        <mat-label>How many years NCD?</mat-label>
        <mat-select formControlName="ncd" class="form-control form-control-sm">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let n of staticData.ncd_options" [value]="n">{{n}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

</form>
